import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { ChecklistItem } from 'components/checklist';
import PropTypes from 'prop-types';

import DataTableContext from './DataTableContext';
import DataTableHeaderCell from './DataTableHeaderCell';

class DataTableSelectAll extends PureComponent {
  // #region set up
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };
  // #end region

  // #region render
  render() {
    const { className } = this.props;
    const classComponent = classNames('data-table-select-cell', className);

    return (
      <DataTableContext.Consumer>
        {({ actions, data }) => (
          <DataTableHeaderCell
            key="row-header-cell-select-all"
            className={classComponent}
          >
            <ChecklistItem
              item={{ checked: data.selectAll }}
              onChange={(event) => actions.onSelectAll(event)}
            />
          </DataTableHeaderCell>
        )}
      </DataTableContext.Consumer>
    );
  }
  // #endregion
}

export default DataTableSelectAll;
